/**
 * Constants used for collaborative document operations.
 * 
 * This frozen object contains various string constants used throughout
 * the collaborative document feature, ensuring consistent usage across the codebase.
 */

export const CollaborativeDocumentConstants = Object.freeze({
    v1_create: "v1/create",
    extension_document: "extension_document",
    document: "document",
    extensions: "extensions",
    metadata: "metadata",
    injected: "@injected",
    post: "POST"
})